class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.watchForPointerBelowContent();
    } else {
      this.stopWatchingForPointerBelowContent();
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  // Auto-collapse the menu once the pointer moves past the bottom edge of the
  // open panel, rather than requiring a click elsewhere or a focus change.
  // The panel's position is measured once here (on open) instead of on every
  // pointermove, since re-measuring on every mouse movement forces a layout
  // read dozens of times a second for no benefit.
  watchForPointerBelowContent() {
    const contentBottom = this.content.getBoundingClientRect().bottom;
    this.onPointerMove = (event) => {
      if (event.clientY > contentBottom) this.close();
    };
    document.addEventListener('pointermove', this.onPointerMove);
  }

  stopWatchingForPointerBelowContent() {
    if (!this.onPointerMove) return;
    document.removeEventListener('pointermove', this.onPointerMove);
    this.onPointerMove = undefined;
  }
}

customElements.define('header-menu', HeaderMenu);
